import React from "react";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import "components/bookingPopUp/golferCard/GolferCard.scss";

import Icon from "components/icon/Icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { faCircleG } from "@fortawesome/pro-solid-svg-icons";

function GolferCard(props: any) {
  return (
    <div className={classNames("golfer-card", props?.className as string)} style={{ alignItems: props?.bookingEngineCard ? "center" : "" }}>
      <div className="golfer-card-details">
        <p className="golfer-card-name">{props.name} {props?.guest ? (<FontAwesomeIcon icon={faCircleG} size="1x"/>) : null}</p>
        <div className="golfer-card-details-info">
          <p className="golfer-card-email">{props.customerType}</p>
          <p className="golfer-card-email">{props.email}</p>
          <p className="golfer-card-phone">{props.phone ? props.phone : null}</p>
        </div>
      </div>

      {props?.has_high_priority_notes ? (
        <div className="ml-8 mt-2">
          {props.has_high_priority_notes ? (
            <FontAwesomeIcon className="text-error" icon={["far", "circle-exclamation"]} size="lg" />
          ) : null}
        </div>
      ) : null}

      <div className="golfer-card-id-close-container">
        <div className="customerId">
          <span className="golfer-card-customer-id">{props.memberCode}</span>
        </div>
        {props?.closable && (
          <div className="close-button-container">
            <button className="golfer-card-close-button" onClick={props.removeGolfer}>
              <Icon icon={faTimes} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default GolferCard;
